var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.6875V8.51249C16.5 9.46499 16.185 10.2675 15.6225 10.8225C15.0675 11.385 14.265 11.7 13.3125 11.7V13.0575C13.3125 13.5675 12.7425 13.875 12.3225 13.59L11.595 13.11C11.6625 12.8775 11.6925 12.6225 11.6925 12.3525V9.30002C11.6925 7.77002 10.6725 6.75 9.1425 6.75H4.05C3.945 6.75 3.8475 6.75752 3.75 6.76502V4.6875C3.75 2.775 5.025 1.5 6.9375 1.5H13.3125C15.225 1.5 16.5 2.775 16.5 4.6875Z",
    stroke: "#008000",
    strokeWidth: 1.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6925 9.30002V12.3525C11.6925 12.6225 11.6625 12.8775 11.595 13.11C11.3175 14.2125 10.4025 14.9025 9.14251 14.9025H7.1025L4.8375 16.41C4.5 16.6425 4.05 16.395 4.05 15.99V14.9025C3.285 14.9025 2.6475 14.6475 2.205 14.205C1.755 13.755 1.5 13.1175 1.5 12.3525V9.30002C1.5 7.87502 2.385 6.89251 3.75 6.76501C3.8475 6.75751 3.945 6.75 4.05 6.75H9.14251C10.6725 6.75 11.6925 7.77002 11.6925 9.30002Z",
    stroke: "#008000",
    strokeWidth: 1.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsIcon);
export default __webpack_public_path__ + "static/media/chatsIcon.473f2401c6cab69123eeb83aeeddc39b.svg";
export { ForwardRef as ReactComponent };